import { AsyncPipe } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SharedBreadcrumbComponent } from '@lemans/shared';
import { UserDataFacade } from '@ra-state';
import { IBreadcrumbItem } from '@ra-web-tech-ui-toolkit/components';
import { BreadcrumbService } from '@servicesV2/breadcrumb.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-navigation',
  styleUrls: ['./navigation.component.scss'],
  templateUrl: './navigation.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [SharedBreadcrumbComponent, AsyncPipe],
})
export class NavigationComponent {
  private readonly router = inject(Router);
  private readonly userDataFacade = inject(UserDataFacade);
  private readonly breadcrumbService = inject(BreadcrumbService);

  currentCustomProvisioningData$ = this.userDataFacade.currentCustomProvisioningData$;
  breadcrumbs$: Observable<IBreadcrumbItem[]> = this.breadcrumbService.breadcrumbs$;
  title$: Observable<string> = this.breadcrumbService.title$;

  navigateSignal$ = toObservable(this.breadcrumbService.$navigateSignal).pipe(
    tap((path) => {
      if (path) {
        this.router.navigate([path]);
      }
    }),
  );

  onClicked($event: IBreadcrumbItem): void {
    // Reset the signal previous value before setting a new one
    this.breadcrumbService.$navigateSignal.set(null);
    // Notify the breadcrumb service about the clicked breadcrumb
    this.breadcrumbService.onClicked($event);
  }
}
